import { useCallback, useEffect, useState } from "react";
import { EPaymentIframes } from "../../interface/IPayment";
import { IPayer } from "../interface/IManageCards";
import { payerRoute } from "@api-routes/payments";
import { getResponseToState, IPayerResponse } from "../mappers/getPayerDetailsMapper";
import { useFetch } from "@common/hook/useFetch";
import { IError } from "itsf-ui-common";

interface IParams {
    setOpenedPaymentIframe(openedIframe?: EPaymentIframes): void;
    accountId?: string;
}

export const usePayerDetails = (props: IParams) => {
    const { setOpenedPaymentIframe, accountId } = props;
    const [getPayerState, { get }] = useFetch();

    const [payerDetails, setPayerDetails] = useState<IPayer>();
    const [cardError, setCardError] = useState<IError>();

    const getPayerDetails = useCallback(() => {
        if (accountId) {
            setPayerDetails(undefined);
            setOpenedPaymentIframe();

            get<IPayerResponse>(payerRoute(accountId), {
                forwardError: true,
                headers: {
                    "Cache-Control": "no-cache",
                },
            })
                .then((payerResponse) => {
                    if (payerResponse) {
                        setPayerDetails(getResponseToState(payerResponse));
                    }
                })
                .catch(setCardError);
        }
    }, [accountId, get, setOpenedPaymentIframe]);

    useEffect(getPayerDetails, [getPayerDetails]);

    return {
        cardError,
        setCardError,
        getPayerState,
        getPayerDetails,
        payerDetails,
    };
};
